import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import {
  Row, Col, Card, CardBody, CardTitle, Button,
} from 'reactstrap';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

import { get } from '../../helpers/api_helper';
import { Can } from '../../utilities/Can';
import ItemForm from '../../components/Item/ItemForm';
import * as url from '../../helpers/url_helper';

function CreateItemForm(props) {
  const history = useHistory();
  const [createSimilar, setCreateSimilar] = useState(false);
  const [formBusy, setFormBusy] = useState(false);
  const { id } = useParams();

  const onSuccess = (itm) => {
    toastr.success(`Created item ID: ${itm.id}`, 'Success');

    if (createSimilar === false) {
      history.push(`/item/${itm.id}`);
    } else {
      history.push(`/items/create/${itm.id}`);
    }
  };

  const [entity, setEntity] = useState({
    identifiers: [],
    images: [],
    part_number: '',
    manufacturer: '',
    weight: null,
    ship_dims: '',
    boardNumbers: [],
    devices: [],
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        const item = await get(`${url.GET_ITEM}/${id}`);

        setEntity({
          condition: ['Brand New', 'Like New'].includes(item.condition) ? item.condition : 'Like New',
          scrap: 999,
          identifiers: [],
          images: [],
          part_number: '',
          manufacturer: item.manufacturer,
          device_manufacturer: item.device_manufacturer,
          customs_description: item.tags.map((tag) => tag.label).join(', ').substring(0, 35),
          boardNumbers: [
            {
              label: 'Manufacturer Part Number',
              value: '',
            },
            {
              label: 'Visible Number',
              value: '',
            },
          ],
          devices: item.devices,
          tags: item.tags,
        });
      } catch (e) {
        toastr.error(e.message, 'Error');
      }
    };

    if (id) {
      fetchData();
    }
  }, []);

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Can i="make" this="Items">
            <Col xxl="6">
              <Card>
                <CardBody>
                  <CardTitle className="h4">{props.t('New Item')}</CardTitle>
                  <ItemForm
                    actionUrl={url.POST_ITEM}
                    entity={entity}
                    onSuccess={onSuccess}
                    onBusyChange={setFormBusy}
                  />
                  <hr />
                  <div className="row justify-content-end">
                    <Col sm={9}>
                      <div className="d-flex flex-row-reverse bd-highlight gap-2">
                        <Button
                          type="submit"
                          form="ItemEditForm"
                          color="primary"
                          className="w-md"
                          disabled={formBusy}
                        >
                          {formBusy ? props.t('Adding models...') : props.t('Submit')}
                        </Button>
                        <Button
                          type="button"
                          color="soft-info"
                          className="w-md text-dark"
                          onClick={() => { history.goBack(); }}
                        >
                          {props.t('Cancel')}
                        </Button>

                        <div className="form-check me-3 mt-2">
                          <input className="form-check-input" type="checkbox" checked={createSimilar} id="createSimilar" onChange={() => { setCreateSimilar(!createSimilar); }} />
                          <label className="form-check-label" htmlFor="createSimilar">{props.t('Create Similar')}</label>
                        </div>
                      </div>
                    </Col>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Can>
        </Row>
      </div>
    </div>
  );
}

CreateItemForm.propTypes = {
  // eslint-disable-next-line react/require-default-props
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(CreateItemForm));
